import { useSelector } from 'react-redux';
import { selectDealershipSettings } from 'services/DealershipSettings/selectors';
import { FRONTEND_DOMAIN } from '../env';
import { URLPrefix } from 'constants/common';
import { BrandingTypes } from 'services/resources';

export const getHostnamePrefix = (): URLPrefix => {
  const hostname = window.location.hostname;
  const domainPrefix = hostname.split('.')[0] as URLPrefix;

  if (![URLPrefix.FLEETLANE, URLPrefix.WEEVE, URLPrefix.AVIGO].includes(domainPrefix)) {
    throw new Error('Invalid domain prefix');
  }

  return domainPrefix;
};

const redirectTo = (brandingType: URLPrefix) => {
  const redirectURL = new URL(window.location.href);
  redirectURL.host = `${brandingType}.${FRONTEND_DOMAIN}`;

  localStorage.removeItem('api_token');
  window.location.replace(redirectURL);
};

const brandingToPrefixMapping = {
  [BrandingTypes.FLEETLANE]: URLPrefix.FLEETLANE,
  [BrandingTypes.WEEVE]: URLPrefix.AVIGO,
  [BrandingTypes.AVIGO]: URLPrefix.AVIGO,
};

/*
 * Redirects user to the appropriate host based on branding type.
 */
const useBranding = () => {
  const { brandingType } = useSelector(selectDealershipSettings());
  const brandingPrefix = brandingToPrefixMapping[brandingType];

  if (brandingType) {
    try {
      const currentHostnamePrefix = getHostnamePrefix();
      if (currentHostnamePrefix !== brandingPrefix) {
        redirectTo(brandingPrefix);
      }
    } catch (error) {
      redirectTo(URLPrefix.FLEETLANE);
    }
  }
};

export default useBranding;
